import React from "react"; // eslint-disable-line no-unused-vars
import { makeStyles } from "@material-ui/core/styles";
import {
  Grid,
  Typography,
  Card,
  CardActionArea,
  CardMedia,
  CardContent,
  Link,
} from "@material-ui/core";

export default function SearchResults({ categoryID, charities }) {
  const useStyles = makeStyles((theme) => ({
    results: { margin: "auto" },
    card: {
      height: "100%",
      minHeight: "215px",
      position: "relative",
    },
    media: {
      width: "100%",
    },
    button: {
      "&:hover": { background: "none", boxShadow: "none" },
      "&:active": { background: "none", boxShadow: "none" },
    },
  }));
  const classes = useStyles();

  return (
    <Grid item container xs={12} spacing={2} className={classes.results}>
      {charities.map((charity) => {
        return (
          <Grid
            item
            xs={12}
            sm={4}
            md={3}
            key={charity.ein}
            itemScope
            itemType="https://schema.org/Organization"
          >
            <Link
              href={`/charity/${encodeURI(
                charity.name
              )}/?categoryID=${categoryID}&ein=${charity.ein}`}
            >
              <Card className={classes.card}>
                <CardActionArea className={classes.button}>
                  <CardMedia
                    className={classes.media}
                    itemProp="image"
                    component="img"
                    alt={charity.name + " Charity"}
                    image={charity.image}
                    title={charity.name}
                  />
                  <CardContent>
                    <Typography
                      gutterBottom
                      align="center"
                      component="h2"
                      itemProp="name"
                    >
                      {charity.name}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Link>
          </Grid>
        );
      })}
    </Grid>
  );
}
